import { observer } from 'mobx-react-lite'
import { links } from '@/utils/link'
import { type SearchableJob } from '@/features/jobs/list/SearchableJob'
import { type JobManagementViewModel } from '@/features/jobs/list/JobManagementViewModel'
import { JobsTableRow } from '@/features/jobs/list/components/JobManagement/JobsTable/JobsTableRow'
import { JobsTableCellContainer } from '@/features/jobs/list/components/JobManagement/JobsTable/JobsTableCellContainer'

export interface JobsTableRowContainerProps {
  vm: JobManagementViewModel
  job: SearchableJob
}

export const JobsTableRowContainer = observer(function JobsTableRowContainer({
  vm,
  job,
}: JobsTableRowContainerProps) {
  return (
    <JobsTableRow
      to={!job.archived ? links.job(job.id) : undefined}
      testId={'job-list-item-' + job.name}
    >
      <JobsTableCellContainer vm={vm} job={job} />
    </JobsTableRow>
  )
})
